import EventDispatcher from "@/events/EventDispatcher";
import { AppEvent } from "@/events/AppEvent";
import { Howl } from "howler";
import { gsap } from "gsap";

export default class BGMSound extends EventDispatcher {
  public audio: HTMLAudioElement;
  public bgmSound: Howl;
  public isLoaded: boolean = false;
  public label: string = '';
  public type: string = '';
  
  protected basisVolume: number = 1;
  protected limitDistance: number = 30;
  protected attenuate: number = 1;
  protected _volume: number = 1;
  protected _distance: number = 1;
  protected _elevation: number = 0;
  
  
  constructor (src: string, basisVolume: number = 1, limitDistance: number = 30, attenuate: number = 1) {
    super();
    this.bgmSound = new Howl({
      src: [src],
      loop: true,
      preload: false
    });
    this.basisVolume = basisVolume;
    this.volume = 1;
  }
  
  
  public load(): void {
    this.bgmSound.once('load', () => {
      this.isLoaded = true;
      this.dispatchEvent(AppEvent.LOAD_COMPLETE);
    });
    this.bgmSound.load();
  };
  
  /**
   * ボリュームを設定する(0〜1.0)
   * @param value
   */
  set volume (value: number) {
    this._volume = value;
    this.bgmSound.volume(this._volume * this.basisVolume);
  }
  get volume (): number { return this._volume; }
  
  /**
   * 再生メソッド
   * @param fade {boolean} フェードインして再生するかどうか
   */
  play = (fade: boolean = false): void => {
    if (fade) {
      this.volume = 0;
      this.bgmSound.play();
      gsap.to(this, {
        volume: 1,
        duration: 3.0,
        overwrite: true
      });
    }
    else {
      this.bgmSound.volume(this._volume * this.basisVolume);
      this.bgmSound.play();
    }
  };
  
  /**
   * 一時停止メソッド
   * @param fade {boolean} フェードアウトして停止するかどうか
   */
  pause = (fade: boolean = false): void => {
    if (fade) {
      gsap.to(this, {
        volume: 0,
        duration: 2.0,
        overwrite: true,
        onComplete: () => {
          this.bgmSound.pause();
        }
      });
    }
    else {
      this.bgmSound.pause();
    }
  };
  
  stop = (): void => {
    this.bgmSound.stop();
  };
  
  mute = (): void => {
    this.bgmSound.mute(true);
  };
  
  clearMute = (): void => {
    this.bgmSound.mute(false);
  };
  
}
